import { render, staticRenderFns } from "./AboutLayout1.vue?vue&type=template&id=537e5437"
import script from "./AboutLayout1.vue?vue&type=script&lang=js"
export * from "./AboutLayout1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports